import { Injectable } from '@angular/core';
import { IEntityTypeOption, ISharedServiceProviderService } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';

@Injectable({ providedIn: 'root' })
export class EntityTypeMappingsService {
  private readonly serviceProvider: ISharedServiceProviderService;

  constructor(
    identityStorage: IdentityStorage,
    sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory,
  ) {
    const namespace = identityStorage.get().namespace;
    this.serviceProvider = sharedServiceProviderServiceFactory.getServiceProviderService(namespace);
  }

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    return this.serviceProvider.getEntityTypeOptions(parentEntityType);
  }
}
